export const getUserOrders = (payload?: { id: number, page?: number, perPage?: number, search?: string, status: "NEW" | "PROCESSED" }) => ({
    type: "@saga/GET_USER_ORDERS",
    payload
});